import Tooltip from "@mui/material/Tooltip";
import { withStyles } from "tss-react/mui";

export const LightTooltip = withStyles(Tooltip, (theme) => ({
    tooltip: {
        backgroundColor: theme.palette.common.white,
        color: "rgba(0, 0, 0, 0.87)",
        boxShadow: theme.shadows[1],
    },
}));

export const LightTooltipWithBorder = withStyles(Tooltip, (theme) => ({
    tooltip: {
        backgroundColor: theme.palette.common.white,
        border: `1px solid #cacaca`,
        padding: 1,
    },
    arrow: {
        color: theme.palette.common.white,
        "&:before": {
            border: "1px solid #cacaca",
        },
    },
}));

export const ScrollableLightTooltipWithBorder = withStyles(Tooltip, (theme) => ({
    tooltip: {
        backgroundColor: theme.palette.common.white,
        border: `1px solid #cacaca`,
        margin: "6px",
        maxHeight: "30vh",
        overflow: "auto",
        color: "black",
        "&::-webkit-scrollbar": {
            width: theme.spacing(1.3),
        },
        "&::-webkit-scrollbar-track": {
            borderLeft: `${theme.spacing(0.5)} solid rgba(0, 0, 0, 0)`,
            backgroundClip: "padding-box",
            backgroundColor: theme.palette.grey[100],
        },
        "&::-webkit-scrollbar-thumb": {
            borderLeft: `${theme.spacing(0.5)} solid rgba(0, 0, 0, 0)`,
            backgroundClip: "padding-box",
            backgroundColor: theme.palette.grey[300],
        },
    },
}));
